import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedModule } from '../shared.module';
import { FormSharedModule } from '../form-shared.module';
import { IngresoComponent } from './ingreso.component';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { RecuperacionDatosComponent } from './recuperacion-datos.component';
import { UsuariosService } from '../../_services/usuarios.service';
import { FuncionalidadesService } from '../../_services/funcionalidades.service';
import { TerceroCargoService } from '../../_services/tercero-cargo.service';
import { ContactRolesSolicitudesService } from '../../_services/contact-roles-solicitudes.service';
import {ContenedorCaidoLoadingModule} from "../contenedor-caido-loading/contenedor-caido-loading.module";
import {CommonModule, NgStyle} from '@angular/common';
import {DialogModule} from 'primeng/dialog';
import {GoogleSigninButtonModule} from '@abacritt/angularx-social-login';

@NgModule( {
  declarations: [
    IngresoComponent,
    RecuperacionDatosComponent,
  ],
    imports: [SharedModule, FormSharedModule, ContenedorCaidoLoadingModule, NgStyle, DialogModule, CommonModule, GoogleSigninButtonModule],
  providers: [ AutenticacionService, UsuariosService, FuncionalidadesService, TerceroCargoService, ContactRolesSolicitudesService ],
  exports: [ IngresoComponent, RecuperacionDatosComponent ]
} )

export class AutenticacionModule {

}
